import * as THREE from 'three';
import { FLASHLIGHT } from '../constants';

export class Flashlight {
  light: THREE.SpotLight;
  target: THREE.Object3D;
  isOn = true;

  constructor(scene: THREE.Scene) {
    this.light = new THREE.SpotLight(
      FLASHLIGHT.COLOR,
      FLASHLIGHT.INTENSITY,
      FLASHLIGHT.DISTANCE,
      FLASHLIGHT.ANGLE,
      FLASHLIGHT.PENUMBRA,
      FLASHLIGHT.DECAY
    );
    this.light.castShadow = true;
    this.light.shadow.mapSize.set(FLASHLIGHT.SHADOW_MAP_SIZE, FLASHLIGHT.SHADOW_MAP_SIZE);
    this.light.shadow.camera.near = 0.1;
    this.light.shadow.camera.far = FLASHLIGHT.DISTANCE;

    this.target = new THREE.Object3D();
    this.light.target = this.target;

    scene.add(this.light);
    scene.add(this.target);
  }

  toggle(): void {
    this.isOn = !this.isOn;
    this.light.visible = this.isOn;
  }

  update(camera: THREE.PerspectiveCamera): void {
    this.light.position.copy(camera.position);
    // Offset slightly down to simulate weapon-mounted light
    this.light.position.y -= 0.15;

    const dir = new THREE.Vector3();
    camera.getWorldDirection(dir);
    this.target.position.copy(camera.position).add(dir.multiplyScalar(5));
  }

  dispose(scene: THREE.Scene): void {
    scene.remove(this.light);
    scene.remove(this.target);
    this.light.dispose();
  }
}
